import { useInfiniteQuery } from "@tanstack/vue-query";
import baseAPI from "@/api/base";
import { computed, Ref } from "vue";

interface NotificationParams {
  createdById: string | null;
  organizationId: string | null;
  contactId?: string | null;
  limit?: number;
}

export function useNotifications(params: Ref<NotificationParams>) {
  const enabled = computed(() => !!params.value.createdById && !!params.value.organizationId);

  return useInfiniteQuery({
    queryKey: ["notifications", params],
    queryFn: async ({ pageParam = 1 }) => {
      if (!params.value.createdById || !params.value.organizationId) return null;

      const response = await baseAPI.get("/notification", {
        params: {
          createdById: params.value.createdById,
          organizationId: params.value.organizationId,
          ...(params.value.contactId ? { contactId: params.value.contactId } : {}),
          page: pageParam,
          limit: params.value.limit || 15,
        },
      });

      return {
        data: response.data.data || [],
        pagination: response.data.metaData || { currentPage: 1, totalPages: 1 },
      };
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (!lastPage?.pagination) return undefined;
      const { currentPage, totalPages } = lastPage.pagination;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    enabled,
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
  });
}
